/* eslint-disable @typescript-eslint/no-unused-vars */
import { InvoiceType } from '~api/types'
import storeInfo from '../store'

export const getInvoicePreview = () => (): InvoiceType => {
  const { invoice: { invoicePreview } } = storeInfo.store.getState()
  return invoicePreview
}

export const getInvoicePDFPath = () => (): string => {
  const { invoice: { invoicePath } } = storeInfo.store.getState()
  return invoicePath
}

export const getInvoicesForClient = () => (): InvoiceType[] => {
  const { invoice: { invoices } } = storeInfo.store.getState()
  return invoices
}